import { SectionHeader } from "common/components/SectionHeader";
import React, { useContext } from "react";
import Typography from "@mui/material/Typography";
import { LanguageContext } from "configuration/app-context-manager/LanguageContext";
import Data from "./data/index.json";
import { Box, Container } from "@mui/material";

export const Policy = () => {
  const { language } = useContext(LanguageContext);
  return (
    <Box mt={10} mb={12}>
      <SectionHeader
        title={Data[language].title}
        subtitle={Data[language].subtitle}
      />
      <Container maxWidth="sm">
        {Data[language].texts.map((t, id) => (
          <Typography
            variant="body1"
            key={id}
            mb={id === Data[language].texts.length - 1 ? 0 : 3}
            sx={{
              textAlign: "center",
              lineHeight: 2,
              fontSize: { xs: "0.9rem", md: "0.95rem" },
              color: "#4a4a4a",
            }}
          >
            {t.text}
          </Typography>
        ))}
      </Container>
    </Box>
  );
};
